<template>
    <div>
        Unknow row component : {{row.type}}
        <div 
        class="small"
        v-if="row.type == 'custom'">
            Details : {{row.data.custom}}
        </div>
    </div>
</template>


<script>

    export default {

        props: {
            row: {
                type: Object,
                default: () => {}
            }
        }

    }
</script>